import React, { useEffect } from 'react'
import SearchFilters from './SearchFilters/SearchFilters';
import SearchResults from './SearchResults/SearchResults';
import styles from './styles.module.css'

export default function PeopleDataDR14() {

    useEffect(() => {
        localStorage.setItem("dfp/dataTypeNavigation", "people");
        document.title = "Datafiniti Portal | People"
        window.scrollTo(0, 0)
    }, []) /* eslint-disable-line react-hooks/exhaustive-deps */


    return (
        <main className={styles.mainContainerPeople}>
            <SearchFilters />
            <SearchResults />
        </main>
    )
}
